import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_INFRACTIONS](state, data) {
    state.allInfractions = data
  },
}
